import { render, staticRenderFns } from "./SupervisorDashboard.vue?vue&type=template&id=45083fc8&scoped=true"
import script from "./SupervisorDashboard.vue?vue&type=script&lang=js"
export * from "./SupervisorDashboard.vue?vue&type=script&lang=js"
import style0 from "./SupervisorDashboard.vue?vue&type=style&index=0&id=45083fc8&prod&scoped=true&lang=css"
import style1 from "./SupervisorDashboard.vue?vue&type=style&index=1&id=45083fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45083fc8",
  null
  
)

export default component.exports